// extracted by mini-css-extract-plugin
module.exports = {"widgetGenerator":"styles_widgetGenerator__1xsLa","widgetGeneratorLayout":"styles_widgetGeneratorLayout__rQELb","widgetView":"styles_widgetView__1gkfu"};